module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“O")])]), _vm._v("ur school program will be so much fun. We’re going to do a play and sing songs. I have a poem to recite all by myself. I can’t wait for Christmas.” Eight-year-old Anna Imhoff leaned out the side of their Amish buggy to let the breeze twirl a ribbon she held in her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen Imhoff listened to her little sister’s excited prattle with only half an ear. Christmas was still eight weeks away. There were more pressing problems on Karen’s plate, like buying shoes for three growing children, her father’s mounting medical bills and finding a job until he was fully recovered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna sat back and grabbed Karen’s sleeve. “Look, there’s a dead man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before Karen could respond to Anna’s startling comment, the horse pulling the buggy shied violently, then bolted. Caught off guard, Karen was thrown back against the leather seat as the mare lunged forward. Anna screamed at the top of her lungs. Her brothers in the backseat began yelling. The horse plunged ahead even faster.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Regaining her balance, Karen grasped the loose reins. She braced her feet against the floorboards and pulled back hard. “Whoa, Molly, whoa!”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Molly paid no heed. The buggy bounced and swayed violently as the mare charged down the farm lane. Mud thrown up by her hooves splattered Karen’s dress and face. Gritty dirt mixed with the acid tang of fear in her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna, still screaming, threw her arms around Karen’s waist, further hampering her efforts to gain control. The horse had to be stopped before they reached the highway at the end of the lane or upended in the ditch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Muscles burning, Karen fought Molly’s headlong plunge. A quarter of a mile flew past before Molly gave in. The horse slowed and came to a stop a few feet shy of the highway just as a red pickup zipped past. The brown mare tossed her head once more but didn’t seem inclined to run again. Karen sent up a heartfelt prayer of thanks for their deliverance then took stock of her passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna, with her face buried in the fabric of her sister’s dress, maintained her tight grip. “I don’t like to go fast. Don’t do that again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen comforted her with a quick hug and loosened the child’s arms. “I won’t. I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning to check on her brothers, Karen asked, “Jacob? Noah? Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fourteen-year-old Jacob retrieved his broad-brimmed black hat from the floor, dusted it off and jammed it on his thick, wheat-colored hair. “I’m fine. I didn’t know Molly could move like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ten-year-old Noah sat slumped down beside his brother. He held his hat onto his head in a tight grip with both hands. The folded brim made it look like a bonnet over his red curls. He said, “That was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought it was,” Jacob countered. “What spooked her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure.” Karen’s erratic heartbeat gradually slowed to a normal pace.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brushing at the mud on her dress, Anna said, “Maybe Molly was scared of the dead man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What dead man?” Noah leaned forward eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The one back there.” Anna pointed behind them. They all twisted around to look. Karen saw only an empty lane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jacob scowled at his little sister. “I don’t see anything. You’re making that up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am not. You believe me, don’t you, Karen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hugging the tearful child, Karen wasn’t sure what to believe. Anna had been the only survivor of the buggy and automobile crash that had killed their mother, two sisters and their oldest brother four years earlier. The child worried constantly about death taking another member of her family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen looked into Anna’s eyes. “I’m sure you saw something. A plastic bag or a bundle of rags perhaps.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jacob, impatient as ever, said, “There’s nothing back there. Let’s go. I don’t want to be late for school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can’t leave him there,” Anna insisted, her lower lip quivering ominously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Noah started to climb out. “I don’t mind being late. I’ll go look.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Forestalling him, Karen said, “No. We’ll all go back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna could easily become hysterical and then they would get nowhere. It was better to show the child that she had been mistaken. After that, Karen could drop the children at their one-room schoolhouse and hurry to her interview at Bishop Zook’s home. It wouldn’t do to be late for such an important meeting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("When the wedding banns had been announced for the current schoolteacher, Karen knew it meant a new teacher would have to be hired. With money tight in the ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Imhoff household the job would be perfect for Karen and bring in much-needed funds.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The church-district elders were speaking to teaching applicants this morning. She had to be there. But first she needed to convince Anna they didn’t have a dead man on their lane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning the horse around, Karen sent her walking back the way they had come. As they neared the start of their reckless run Molly balked, throwing up her head and snorting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not wishing to have a repeat of the mad dash, Karen said, “Jacob, take the lines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He scrambled over the seat back to sit beside her. After handing him the driving reins Karen stepped down from the buggy. Her sturdy black shoes sank into the ground still soft from last night’s rain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The morning sun, barely over the horizon, had started to burn away the fog lingering in the low-lying farm fields. Where the sunlight touched the high wooded hillsides it turned the autumn foliage to burnished gold and scarlet flame. A breeze tugged at the ribbons of Karen’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kapp")]), _vm._v(" and brought with it the smell of damp grasses and fallen leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Walking briskly back toward their farmhouse, she scanned the shallow ditch beside the road without seeing anything unusual. Turning around in the road, she looked at the children and raised her arms. “I don’t see anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Farther back,” Anna yelled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Dropping her hands, Karen shook her head, but started walking. Anna had been leaning out her side of the carriage. She would have had a good view of the ditch. Karen had been paying attention to the problems facing ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("her family and not to the road. A mistake she would not make again.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few yards farther along the lane she caught a glimpse of something white in the weeds. At first she thought she’d been right and it was a bundle of cloth or a stray plastic bag caught in the brush. Then the breeze brought her a new smell—the sickly metallic odor of blood. A low moan made her jump like a startled rabbit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Taking a few hesitant steps closer, she saw a man sprawled on his back, his body almost completely hidden in the grass and wild sumac. His face looked deathly pale beneath close-cropped black hair. Blood had oozed from an ugly gash on the side of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In an instant, Karen was transported back to that terrible day when she had stood beside the remains of the smashed buggy where her mother and sisters lay dead and her brother lay dying.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She squeezed her eyes shut. Pressing her hands to her face, she whispered, “Not again, Lord, do not ask this of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you find something?” Noah yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jerked back to the present, Karen shouted, “Stay there!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She approached the downed man with caution. He was an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englischer")]), _vm._v(" by the look of his clothes. The muddy white shirt he wore stretched tightly across his chest and broad shoulders while his worn jeans hugged a lean waist and muscular thighs. Oddly, both his shoes were missing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moaned, and she moved to kneel at his side. “Sir? Sir, can you hear me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a dead man!” Noah stood on the roadway looking down with wide eyes.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She scowled at her brother. “He is not dead. I told you to wait in the buggy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you sure he isn’t dead?” The boy’s voice brimmed with excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laying a hand on the man’s cheek, Karen became alarmed by how cold his skin was. He might not be dead, but he wasn’t far from it. “Run to the phone shack and call for help. Do you know how to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Noah nodded. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ja,")]), _vm._v(" I dial 9-1-1.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goot.")]), _vm._v(" Hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She watched her brother climb over the fence and head across the muddy field of corn stubble. Their Amish church forbade telephones in the homes of the members, but did allow a community telephone. It was located at a midway point between their home and two neighboring Amish farms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jacob brought the buggy up. When Molly drew alongside the ditch, she snorted and sidled away. Apparently, she didn’t care for the smell of blood. That must have been what frightened her in the first place. Jacob held her in check.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen looked up at him, “Go get Papa.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can’t leave you,” Anna protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jacob drew himself up bravely. “I should stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shaking her head, Karen said, “I’ll be fine. Just go. And bring some quilts. This poor man is freezing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jacob slapped the reins sharply and sent Molly racing up the lane toward the farmhouse. Settling herself beside the injured man, Karen took one of his hands and began to rub it between her own. How had he come to be here?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He groaned and moved restlessly. She squeezed his hand. “You will be okay, sir. My family has gone to get help.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He responded by turning his face toward her. His eyes fluttered open. They were as gray as rain clouds. Encouraged, Karen continued talking to him and rubbing his hand. “My name is Karen Imhoff and this is our farm. Can you tell me who you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He mumbled something. Leaning forward, she positioned her ear near his mouth. His faint, shaky whisper sounded like, “Cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She quickly unbuttoned her coat. Pulling it off, she tucked it around him. Raising his shoulders slightly, she scooted beneath him so his head rested on her lap and not the chilly ground. It wouldn’t help much. His clothes were wet from the rain as was the cold ground he was lying on. Using the corner of her apron, she folded it into a pad and pressed it against the wound on his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moaned again, opened his eyes and focused on her face. “Help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His voice was barely audible but the words he whispered were the same words, the last words, her brother Seth had uttered. She cupped the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englischer")]), _vm._v("’s face, trying to infuse him with her own strength. “Help is coming. Be strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Please, God, do not make me watch him die as I did Seth. Save this man if it is Your will.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With her free hand she stroked his face, offering him what comfort she could. The stubble on his cheeks rasped against her fingertips, sending an unexpected shiver zipping along her nerve endings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His sharply chiseled features were deeply tanned, but his underlying pallor gave his skin a sickly color. His hair lay dark and thick where it wasn’t matted with blood. Dark brows arched finely over his pain-filled eyes.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raising an unsteady hand to touch her face, he fixed her with a desperate gaze and whispered, “Don’t leave me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grasping his cold fingers, she pressed them against her cheek. He might die, but he would not die alone. “I won’t leave you. I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re…so beautiful.” His voice faded. His arm went limp and dropped from her grasp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen tensed. His life couldn’t slip away now, not when help was so close. She shook him and spoke firmly. “Listen to me. Help is coming. You must hang on.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hang on…to you,” he mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tears sprang to her eyes. “Stay with me. Let God be your strength. Hold fast to Him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After several slow breaths, he said, “Yea, though I walk…through…the—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took up the rest of the Twenty-third Psalm for him. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Through the valley of the shadow of death, I will fear no evil: for thou art with me; thy rod and thy staff they comfort me. Thou preparest a table before me in the presence of mine enemies: thou anointest my head with oil; my cup runneth over.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced toward the farm. Where was her father? What was taking so long? Desperately, she prayed help would come in time for the man she held.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearing her throat of its tear-choked tightness, she finished the psalm with a voice that shook. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Surely goodness and mercy shall follow me all the days of my life: and I will dwell in the house of the LORD for ever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Please let Your words bring him comfort, Lord.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It seemed like hours, but finally the buggy came rattling to a stop beside her once more. Her father climbed out gingerly. His left arm rested in a sling with a cast to his shoulder.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was dressed in dark trousers and a dark coat. His plain clothes, long beard and black felt hat proclaimed him a member of the Amish church. His calm demeanor bolstered Karen’s lagging spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What is this, daughter? Anna is wailing about a dead man.” Eli Imhoff pulled a bundle of blankets from the seat. Jacob remained in the buggy, controlling the restless horse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking to her father in relief, she said, “We found him like this, Papa. He is badly hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw him first,” Anna said, making sure everyone understood her contribution.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eli’s eyes grew round behind his wire-rimmed glasses. “An "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englischer?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ja.")]), _vm._v(" He is so cold. I sent Noah to the telephone to call for help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eli stroked his gray-streaked beard, then nodded. “It was the right thing to do. Let us pray he lives until the English ambulance comes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they spread more covers over the man Noah came racing back. He stopped in the lane and braced his hands on his thighs, breathing heavily. “Is he dead yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, and he will not die,” Karen stated so firmly that both her brothers and her father gave her odd looks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t care. She had seen too much death. She wanted this man to live. “Surly God has not led us to him only to snatch his life away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We cannot know "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gotte wille,")]), _vm._v("” her father chided.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("God’s will was beyond human understanding, but Karen prayed He would show His mercy to this unknown man.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“How did he get here?” Jacob asked getting down from the buggy. He handed off the reins to his younger ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("brother. Noah didn’t seem to mind. He stood at Molly’s side transfixed by the sight of the stricken man.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps he was injured on the road and walked this far before he collapsed,” Eli suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Squatting by the stranger’s feet, Jacob shook his head. “He didn’t walk. The bottoms of his socks aren’t even muddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They all glanced at each other as the implications sank in. Someone had dumped this man and left him to die. Karen grew sick at the idea of such cruelty and tightened her hold on him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eli looked at his children and spoke sternly. “This is a matter for the English sheriff. It is outsider business. We must not become involved. Do all of you understand this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boys and Anna nodded. Jacob stepped away and began walking along the ditch toward the highway. Eli scowled at him, but didn’t call him back. A dozen yards down the road Jacob stopped and dropped to his haunches. Karen thought she heard the faint sound of chimes for a second but then nothing more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eli called out to Jacob. “Did you find something?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tire tracks from a car, that’s all.” Rising, Jacob shoved both his hands in his pockets, glanced over his shoulder and then kept walking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the distance, Karen heard the sound of a siren approaching at last. Her father laid a hand on her shoulder. “I will go to the highway to show the English where they are needed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When her father and Noah had driven away, Karen looked down at her stranger. His eyes were open, but his stare was blank. Cupping his cheek, she smiled at him. “Rest easy. Help is almost here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("At the sound of her voice, he focused on her face. He ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("tried to speak, but no words came out. His breath escaped in a deep sigh, and his eyes closed once more.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She bit her lip as she tightened her hold on him. “Just a little longer. You can do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Within moments the sheriff’s SUV and an ambulance arrived, stopping a few feet away. Her father and Noah followed them. One of the paramedics brought his gear and dropped to his knees beside Karen. “I’ll take over now, miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had to let them do their job, but she didn’t want to let go of her stranger. She had promised him she wouldn’t leave him. God had brought her to this man’s side in his hour of need. A deep feeling of responsibility for him had taken hold in her heart, but she realized her job was done.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She cupped his cheek one last time. “You will be fine now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rising, she stepped aside praying she had spoken the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shaking out her damp, muddy skirt, Karen crossed her arms against the chill morning air. With trepidation she saw the sheriff turned his attention her way. He was intimidating, with his gun strapped to his hip and his badge glinting on the front of his leather jacket. Sheriff Nick Bradley was English, but he had family who had remained Plain. Members of Karen’s church believed him to be a fair and impartial officer of the law and friendly toward the Amish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stopping in front of her, he pushed his tan hat up with one finger. “Tell me exactly what happened here this morning, Miss Imhoff.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("He took notes as she answered his questions and then talked to each of the children separately. Karen barely listened to her siblings’ accounts. Her entire attention was ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("focused on the man being cared for by the emergency personnel.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her fingers itched to touch the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englischer")]), _vm._v("’s face again. She wanted to reassure him, and herself, that he was going to be all right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sheriff followed Jacob to where he’d found the tire tracks, took pictures and placed yellow plastic markers at the site. When he finished, he approached Karen’s father. “Mr. Imhoff, the children can go on to school, but I may have more questions for them later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Papa nodded, but Karen could tell he wasn’t pleased. This was outsider business. Papa wanted nothing to do with it. The children, on the other hand, shared excited looks. They would have plenty to tell their friends when they finally got to school. Within a day everyone in the community would know what had taken place on the Imhoff farm this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One of the ambulance crew returned Karen’s coat and then loaded their patient into the ambulance. As she slipped the wool jacket on, she felt the stranger’s warmth surround her. Lifting the collar to her face, she breathed in the spicy-woodsy scent that clung to the dark wool.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His fate was out of her hands now. As the emergency vehicle drove away, she realized she would never see her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englischer")]), _vm._v(" again.")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc75700","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426876530_ch01.vue
// module id = 78
// module chunks = 0